var Gallery = {
    gallery: $('.ze-gallery'),
    modal: $('#galleryModal'),
    initCarousel: function (items, cImage) {
        var carousel = this.modal.find('.gallery-carousel');
        var cImg = cImage.find('img');

        var startingPos = 0;

        // add items to carousel
        items.each(function (i, e) {
            var image = $(e).find('img');

            if (cImg.data('id') == image.data('id')) {
                startingPos = i;
            }

            var html = '<div><div class="item d-flex justify-content-center flex-column"><a class="d-block d-md-flex justify-content-center" href="' + image.attr('src') + '" download="true"><img class="d-block" src="';
            html += image.attr('src') + '" alt="' + image.attr('alt') + '" /></a>';

            var para = image.parent().siblings('p');
            if (para.length > 0) {
                html += '<p class="mt-3 mt-md-5 align-self-start px-0 px-md-3 px-lg-5 ms-lg-5 w-100">' + para.text() + '</p>';
            }

            html += '</div></div>';

            carousel.append(html);
        });

        // init the carousel
        carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '<i class="fa fa-chevron-right slick-next"></i>',
            prevArrow: '<i class="fa fa-chevron-left slick-prev"></i>',
            initialSlide: startingPos
        });
    },
    open: function () {
        var images = this.gallery.find('.ze-gallery-image');
        var modal = this.modal;
        var gallery = this;

        images.on('click', function (evt) {
            evt.preventDefault();

            var image = $(this);
            if (!image.hasClass('ze-gallery-image')) image = image.parents('.ze-gallery-image');

            // init carousel
            gallery.initCarousel(image.parent().children('.ze-gallery-image'), image);

            // disable scrolling
            $('body').css('overflow-y', 'hidden');

            // show modal
            modal.show();
        });
    },
    close: function () {
        var modal = this.modal;
        var closeBtn = modal.find('.gallery-close');

        closeBtn.on('click', function (e) {
            e.preventDefault();

            // disable carousel
            var carousel = modal.find('.gallery-carousel');
            carousel.slick('unslick');

            // enable scrolling
            $('body').css('overflow-y', 'auto');

            // hide modal
            modal.hide();
        });
    },
    eventListeners: function () {
        this.open();
        this.close();
    },
    init: function () {
        this.eventListeners();
    }
}